import { create } from 'zustand'
const roleStore = (set: any) => ({
  role: null,
  organizationId: null,
  setRole: (newState: string) =>
    set(() => ({ role: newState, organizationId: newState })),
})
export const myStore = create(roleStore)
